import React, {useEffect, useState} from "react";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { Typography, DatePicker, Modal, Table, Form, TimePicker, TreeSelect, Row, Col, Input, Tabs, Menu, Badge, Spin } from "antd";
import {
    capitalizeFirstWord,
    errorHandle, generateArrWeekAndDays, getDaysArray, openNotificationWithIcon
} from "../../Function";
import moment from "moment";
import { useSelector } from "react-redux";
import {CloseOutlined, DoubleLeftOutlined, DoubleRightOutlined, CheckOutlined, SearchOutlined
} from "@ant-design/icons";
import {changeStatusCCApi, chotCongApi, tongHopChamCongApi} from "../../../api/getChamcong";
import ListTeamApi, { ListBoPhanApi } from "../../../api/getListTeam";
import SendOutlined from "@ant-design/icons/lib/icons/SendOutlined";
import {LichLeTetApi} from "../../../api/getKhaiBao";
import { DownloadTongHopCongApi } from "../../../api/getInfoData";

const { Text, Link } = Typography;
const { Search } = Input;

const getHeader = (data,date,isHoliday)=>{

    return <span style={{color:isHoliday ? '#cf0000' : ''}}>{new Date(data).getDay() === 0 ? "CN" : "Thứ " + (new Date(data).getDay() + 1)}<br/>{moment(data).format('DD/MM/YYYY')}</span>
}

const RenderItemRow = (text,record,updateData,currentDate,setIsShowDetailItem, setCurrentItem,setCurrentDateSelected)=>{
    return (
        <>
            <div style={{textAlign:'center',width:'100%'}}>
                {text ?
                <RenderSingleInnerItem record={record} text={text} currentDate={currentDate} setIsShowDetailItem={setIsShowDetailItem} setCurrentItem={setCurrentItem} setCurrentDateSelected={setCurrentDateSelected}/>
                :
                "-"}
            </div>
        </>
    )
}

const RenderSingleInnerItem =({record,text,currentDate,setIsShowDetailItem,setCurrentItem,setCurrentDateSelected})=>{
    const getText =(text)=>{
        // switch (text.type) {
        //     case 'Success':
        //         result = text.soGio === 0 ? "-" : text.soGioCong + text.cheDo;break;
        //     case 'Error':
        //         result = text.ghiChu;break;
        //     case 'offDate':
        //         result = '-';break;
        //     case 'Processing':
        //         result = text.gioVao.toString().substr(0,5) + " - " + text.gioRa.toString().substr(0,5);break;
        //     default:
        //         result = '';break;
        // }
        let result;
        if (text.id && text.id !== ''){
            result = text.soGio
            if (text.typeCD !== ''){
                result += "h(" + text.gioCD + "h- " + text.typeCD + ")"
            }
        }
        return result;
    }
    return <>
        <div>
            {getText(text)}
        </div>

    </>
}

export const TongHopCong =()=>{
    const defaultPageSize = 10;
    const [pager, setPager] = useState({pageSize:defaultPageSize, count: 0, current: 1});
    const [data, setData] = useState([{}]);
    const [lsDate, setLsDate] = useState([]);
    const [statusAll, setStatusAll] = useState(null);
    const [lsTeam, setLsTeam] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [lsMemberId, setLsMemberId] = useState([]);
    const [treeData,setTreeData] = useState([]);
    const [currentTeam, setCurrentTeam] = useState([]);
    const [currentItem, setCurrentItem] = useState({});
    const [currentSelectedDate, setCurrentSelectedDate] = useState(moment(new Date()));
    const [currentDateSelected, setCurrentDateSelected] = useState(null);
    const [columns,setColumns] = useState([]);
    const [isShowDetailItem, setIsShowDetailItem] = useState(false);
    const systemGroup = useSelector((state)=>state.systemInfo.systemGroup);
    const [lsIdChamCong, setLsIdChamCong] = useState([]);
    const [isValid, setIsValid] = useState(true);
    const userInfo = useSelector((state)=>state.getUserInfo.userInfo);

    const [lsBoPhan, setLsBoPhan] = useState([]);
    const [currentBoPhan, setCurrentBoPhan] = useState([]);
    const [treeDataBoPhan,setTreeDataBoPhan] = useState([]);
    const [lsAllTeam, setLsAllTeam] = useState([]);
    const [loading_page, setLoading_page] = useState(false);

    const mapDataBCCDetail =(data)=>{
        let results = [];
        let lsMemberId = [];
        let isValid = true;
        let lsIdCCTemp = [];
        for (let i of data) {
            lsMemberId.push(i.id)
            let obj = {};
            obj.id = i.id;
            obj.nhanvien = i.username;
            obj.msnv = i.msnv;
            obj.team = i.team;
            obj.congBu = i.congBu;
            obj.soNgayNghiVuotMuc = i.soNgayNghiVuotMuc;
            obj.soNgayNghiCD = i.soNgayNghiCD;
            obj.congThucLam = i.soNgayCong;
            obj.tongCongLeTet = i.tongCongLeTet;
            obj.congThucNhan = i.congThucNhan;
            obj.status = i.status;
            for (let k of i.data) {
                if (k.type === "Error") {
                    isValid = false
                }
                if (k.id !== '') {
                    lsIdCCTemp.push(k.id);
                }
                obj['col' + moment(k.ngay,"YYYY-MM-DD").format("DDMM")] = k;
            }
            results.push(obj);
        }
        setIsValid(isValid)
        setLsIdChamCong(lsIdCCTemp);
        return [results,lsMemberId]
    }
    const getStyleColorOT = (item) =>{
        let result;
        if (item.type === 'Error'){
            result = "#FFCAAF";
        }
        else {
            switch (item.statusId) {
            // case 1:
            case 4:
                result = 'red';
                break;
            case 2:
                result = '#4ca4f1';break;
            default:
                result = '#ffffff';
                break;
            }
        }

        return result || '';
    }
    const mapColBCCDetail =(data1,arrDay,listNgayLe)=>{
        let col_week = []
        let ls_date = [];
        data1.map(({data})=>{
            data !== [] && data.map((item)=>{
                ls_date.push(moment(item.ngay,"YYYY-MM-DD"))
            })
        });
        const comparisonValues = ls_date.map(v => v.valueOf());
        ls_date = ls_date.filter((v,i) => comparisonValues.indexOf(v.valueOf()) == i);
        ls_date.sort((a, b) => a.diff(b));
        for (let iWeek of arrDay) {
            let colTemp = {}
            colTemp.title = iWeek.name
            colTemp.width = 100
            colTemp.align = 'center'
            let columns_date = [];
            for (let i of iWeek.days) {
                let isHoliday = listNgayLe.filter(item=>item.ngay === i.format('YYYY-MM-DD')).length > 0
                let columns_detail = {};
                let dateTemp = i
                let currentDate = i.format("DDMM");
                columns_detail['title'] = getHeader(dateTemp,lsDate,isHoliday);
                columns_detail['className'] = 'width-100 hoverBlur';
                columns_detail['dataIndex'] = 'col' + currentDate;
                columns_detail['key'] = 'col' + currentDate;
                columns_detail['filterKey'] = 'col' + currentDate;
                columns_detail['type'] = 'text';
                columns_detail['width'] = 100;
                columns_detail['align'] = 'center';
                columns_detail['canSearch'] = true;
                columns_detail['color'] = 'red';
                columns_detail.render = (text,record) => {
                         return {
                            props: {
                                style:{borderRadius:0,background:record['col' + currentDate] ? getStyleColorOT(record['col' + currentDate]) :""},
                                },
                                children: <div>{RenderItemRow(text,record,updateData,currentDate,setIsShowDetailItem,setCurrentItem,setCurrentDateSelected)}</div>
                              };
                    };
                columns_date.push(columns_detail);
            }
            colTemp.children = columns_date
            col_week.push(colTemp)
            // colTemp = {}
        }
        const columns_first = [
            // {
            //     title: "STT",
            //     dataIndex: "index",
            //     key: "index",
            //     render: (value, item, index) => ((pager.current || 1) - 1) * pager.pageSize + index + 1,
            //     sortDirections: ['descend', 'ascend', 'descend'],
            // },
            {
                title: "MSNV",
                dataIndex: "msnv",
                key: "msnv",
                filterKey: 'msnv',
                className:'highlight',
                type: 'text',
                fixed:'left',
                align:'center',
                width:100,
                canSearch: true
            },
            {
                title: "Nhân viên",
                dataIndex: "nhanvien",
                className:'highlight',
                key: "nhanvien",
                filterKey: 'nhanvien',
                fixed:'left',
                width:100,
                align:'center',
                type: 'text',
                canSearch: true
            },
            {
                title: "Team",
                dataIndex: "team",
                key: "team",
                className:'highlight',
                filterKey: 'team',
                type: 'text',
                align:'center',
                width:100,
                fixed:'left',
                canSearch: true
            },
        ]

        const columns_last = [
            {
                title: 'Công bù',
                dataIndex: "congBu",
                key: "congBu",
                filterKey: 'congBu',
                align:'center',
                className:'highlight',
                type: 'text',
                fixed:'right',
                width:100,
                canSearch: true,
            },
            {
                title: 'Số ngày nghỉ vượt mức',
                dataIndex: "soNgayNghiVuotMuc",
                key: "soNgayNghiVuotMuc",
                filterKey: 'soNgayNghiVuotMuc',
                className:'highlight',
                align:'center',
                width:100,
                type: 'text',
                fixed:'right',
                canSearch: true,
            },
            {
                title: 'Số ngày nghỉ CĐ BHXH',
                dataIndex: "soNgayNghiCD",
                key: "soNgayNghiCD",
                fixed:'right',
                filterKey: 'soNgayNghiCD',
                className:'highlight',
                align:'center',
                type: 'text',
                width:100,
                canSearch: true,
            },
                {
                title: 'Tổng công lễ tết',
                dataIndex: "tongCongLeTet",
                key: "tongCongLeTet",
                filterKey: 'tongCongLeTet',
                className:'highlight',
                align:'center',
                fixed:'right',
                width:100,
                type: 'text',
                canSearch: true,
            },
            {
                title: 'Công thực làm',
                dataIndex: "congThucLam",
                key: "congThucLam",
                fixed:'right',
                className:'highlight',
                filterKey: 'congThucLam',
                align:'center',
                type: 'text',
                width:100,
                canSearch: true,
            },
            {
                title: 'Công thực nhận',
                className:'lastColumn highlight',
                dataIndex: "congThucNhan",
                key: "congThucNhan",
                filterKey: 'congThucNhan',
                align:'center',
                fixed:'right',
                width:100,
                type: 'text',
                canSearch: true,
            },

        ]

        let columns = [...columns_first, ...col_week, ...columns_last]
        return columns
    }
    const fetchNgayLe = async (params = {})=> {
         return await LichLeTetApi({...params})
    }

    const fetchData = async (params = {})=>{
        setLoading(true);
        const date = params.date || currentSelectedDate
        const listNgayLe = await fetchNgayLe({nam:moment(params.thoiGian).format("YYYY")})
        tongHopChamCongApi({
            idTeam:params.idTeam,
            thoiGian:moment(params.thoiGian).format("YYYYMM"),
            search
        }).then(r=>{
            const newData = mapDataBCCDetail(r.data);
            const arrDay = generateArrWeekAndDays(new Date(date).getFullYear(),new Date(date).getMonth()+1);
            const newColumns = mapColBCCDetail(r.data,arrDay,listNgayLe.data);
            setData(newData[0]);
            setLsMemberId(newData[1]);
            setColumns(newColumns);
            setLoading(false);
        })
        .catch(err=>{
            errorHandle(err);
            setLoading(false);
        })
    }

    useEffect(() => {
        if (currentSelectedDate && currentTeam.length > 0) {
            fetchData({

                date:currentSelectedDate,
                idTeam:JSON.stringify(currentTeam),
                thoiGian:moment(currentSelectedDate).format("YYYYMM"),
                search
            })
        }
        if (currentTeam.length === 0) {
            setData([{}]);
        }
    }, [currentSelectedDate, currentTeam])

    const fetchListTeam = () =>{
        ListBoPhanApi().then(res=>{
            const arrTeam = userInfo.team_permissions.filter(item=> item.phanquyen__ten_pq === 'working_consolidation_ns')
                                                    .map((item,index)=>{
                                                        const idBoPhanForTeam = res.data.filter(itemBP =>  itemBP.team.some(itemT => itemT.id==item.team) )
                                                        if (idBoPhanForTeam.length != 0){
                                                            return {idTeam:item.team, team:item.team__tenTeam, idBoPhan: idBoPhanForTeam[0].id}
                                                        }
                                                        return false
                                                    }).filter(item => item != false);
            const uniqueArrTeam = [...new Map(arrTeam.map(item =>[item['idTeam'], item])).values()];
            uniqueArrTeam.sort(function(first, second) {
                return first['idTeam'] - second['idTeam'] ;
              });
            const arrIdTeam = uniqueArrTeam.map(item=>item.idTeam)
            const arrBoPhan = res.data.filter(({team}) => team.some(item => arrIdTeam.includes(item.id)) )
            if (arrBoPhan.length > 0) {
                setCurrentBoPhan([arrBoPhan[0].id]);
            }
            setLsBoPhan(arrBoPhan);

            setLsAllTeam(uniqueArrTeam);
            if (currentTeam.length === 0){
                setCurrentTeam([arrIdTeam.filter(x => arrBoPhan[0].team.map(item=>item.id).includes(x))[0]]); // 200423 lấy element đầu tiên đặt trong list
            }
            setLsTeam(uniqueArrTeam.filter(x => arrBoPhan[0].team.map(item=>item.id).includes(x.idTeam)) );
        });
    }

    useEffect(()=>{
        if (userInfo && userInfo.team_permissions && userInfo.team_permissions.length > 0){
            fetchListTeam();
        }

    },[userInfo])

    const updateData=()=>{
        fetchData({
            idTeam:JSON.stringify(currentTeam),
            thoiGian:moment(currentSelectedDate),
            search
        })
    }

    const onChangeBoPhan =(value)=>{
        if (value.length > 0) {
            setCurrentBoPhan(value);
            const lsTeamWith_BP = lsAllTeam.filter(x => value.includes(x.idBoPhan))
            setLsTeam(lsTeamWith_BP);
            setCurrentTeam([lsTeamWith_BP.map(item=>item.idTeam)[0]]); // 200423
        } else {
            setLsTeam([]);
            setCurrentBoPhan([]);
            setCurrentTeam([]);
        };
    }

    const tPropsConfig_BoPhan = {
        treeData:[{
            title:
                currentBoPhan.length > 0 ? (
                <span
                  onClick={() => {if (!loading){onChangeBoPhan([])}}}
                  className="style_SelectTeam"
                >
                  Bỏ chọn tất cả
                </span>
              ) : (
                <span
                  onClick={() => {if (!loading) {onChangeBoPhan(lsBoPhan.map(item=>item.id))}}}
                  className="style_SelectTeam"
                >
                  Chọn tất cả
                </span>
              ),
            value: "xxx",
            disableCheckbox: true,
            disabled: true,
            className: "style_treeTeam"
          },...treeDataBoPhan],
        value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
          onChange:onChangeBoPhan,
        treeCheckable: true,
        // showCheckedStrategy: SHOW_PARENT,
          maxTagCount:2,
        placeholder: 'Chọn bộ phận',
        style:{width:'fit-content',minWidth:200},
        disabled: loading
      };

    useEffect(()=>{
        const treeDataBoPhan = lsBoPhan.map(item=>{return {title: item.tenBophan, value: item.id, key: item.id}})
        setTreeDataBoPhan(treeDataBoPhan);
        if (currentBoPhan.length === 0){
            setCurrentBoPhan(lsBoPhan.map(item=>item.id));
        };
    },[lsBoPhan])

    const onChangeTeam =async (value)=>{
        if (loading){
            return
        }
        if (value.length > 0) {
            setCurrentTeam(value);
        } else {
            setCurrentTeam([]);
        };
        // const waitForFetchData = await fetchData({
        //                                 idTeam:JSON.stringify(value),
        //                                 thoiGian:moment(currentSelectedDate),
        //                                 page:pager.current,
        //                                 page_size:pager.pageSize,
        //                                 search
        //                             })
    }

    const tPropsConfig = {
        treeData:[{
            title:
              !loading && (currentTeam.length > 0 ? (
                <span
                  onClick={() => {setCurrentTeam([]);onChangeTeam([])}}
                  className="style_SelectTeam"
                >
                  Bỏ chọn tất cả
                </span>
              ) : (
                <span
                  onClick={() => {setCurrentTeam(lsTeam.map(item=>item.idTeam));onChangeTeam(lsTeam.map(item=>item.idTeam))}}
                  className="style_SelectTeam"
                >
                  Chọn tất cả
                </span>
              )),
            value: "xxx",
            disableCheckbox: true,
            disabled: true,
            className: "style_treeTeam"
          },...treeData],
        value: treeData.length > 0 ? currentTeam : undefined,
          onChange:onChangeTeam,
        treeCheckable: true,
        // showCheckedStrategy: SHOW_PARENT,
          maxTagCount:2,
        placeholder: 'Chọn team',
        style:{width:'fit-content',minWidth:200},
      };

    useEffect(()=>{
          const treeDataTemp = lsTeam.map(item=>{return {title: <span onClick={()=>{return loading && false }}>{item.team}</span>, value: item.idTeam, key: item.idTeam}})
          setTreeData(treeDataTemp);
        //   setCurrentTeam(lsTeam.map(item=>item.idTeam));
        },[lsTeam])

    // const getDateRange = (date) =>{
    //     const current = date._d.getDay() === 0 ? 7 : date._d.getDay();
    //     const firstDay = new Date(new Date(date).getTime()-((current-1)*24*60*60*1000));
    //     const endDay = new Date(new Date(firstDay).getTime()+(6*24*60*60*1000));
    //     return getDaysArray(firstDay, endDay);
    // };

    const onChangeMonth =(date)=>{
        if (loading){
            return;
        }
        setCurrentSelectedDate(date)
        // fetchData({
        //     date:date,
        //     idTeam:JSON.stringify(currentTeam),
        //     thoiGian:moment(date).format("YYYYMM"),
        //     page:pager.current,
        //     page_size:pager.pageSize,
        //     search
        // })

    };

    const onQuickChangeMonth=(type)=>{
        if (loading){
            return;
        }
        let monthChange;
        if (type === 'previous'){
            monthChange = moment(currentSelectedDate).subtract(1, 'month');
        } else {
            monthChange = moment(currentSelectedDate).add(1, 'month');
        }
        setCurrentSelectedDate(monthChange);
        // fetchData({
        //     date:monthChange,
        //     idTeam:JSON.stringify(currentTeam),
        //     thoiGian:moment(monthChange).format("YYYYMM"),
        //     page:pager.current,
        //     page_size:pager.pageSize,
        //     search
        // })
    }

    const handleChange =(pagination)=>{
        const currentPager = {...pager};
        currentPager.current = pagination.current;
        currentPager.pageSize = pagination.pageSize;
        setPager({...currentPager});
        fetchData({
            status:currentPager.status,
            // page_size:pagination.pageSize,
            // page:pagination.current,
            search
        })
    }
    const onChotCong = ()=>{
        // console.log('Chốt công')
        {/* {userInfo.team_permissions "working_consolidation_accept" */}
        setLoading(true);

        const arrTeam = userInfo.team_permissions.map((item,index)=>item.phanquyen__ten_pq);
        const uniqueArrTeam = [...new Set(arrTeam)];
        // console.log(uniqueArrTeam);
        if (!uniqueArrTeam.includes("working_consolidation_accept")) {
            openNotificationWithIcon('error','Lỗi','Bạn chưa có quyền sử dụng chức năng này.')
        } else {
            chotCongApi({
                idTeam: JSON.stringify(currentTeam),
                thoiGian:moment(currentSelectedDate).format("YYYYMM")
            }).then(r=>{
                openNotificationWithIcon('success','Thành công','')
                updateData();
            })
            .catch(err=>{
                errorHandle(err)
            })
        }
        setLoading(false);
    }
    function disabledMonth(current) {
        // Can not select days after today and today
        const currentDate = new Date();
        return current && current > moment(new Date(currentDate.getFullYear(),currentDate.getMonth()),0).endOf('day');
      }
    // const onExportTongHopCong =()=>{
    //     // console.log('Tải xuống')
    //     openNotificationWithIcon("error",'Lỗi','Chưa làm nhé')
    // }

    const fileDownload_TongHopCong = () => {
        const fnFileDownload = require('js-file-download')
        const filename = "BangTongHopCongChiTiet_" + moment(new Date()).format('YYYYMMDDHHMMSS')  + ".xlsx"
        setLoading_page(true);
        DownloadTongHopCongApi({
            idTeam:JSON.stringify(currentTeam),
            thoiGian:moment(currentSelectedDate).format("YYYYMM"),
            nam:moment(currentSelectedDate).year(),
        }).then(res=>{
            fnFileDownload(res.data, filename);
            setLoading_page(false);
        }) .catch(err=>{
            errorHandle(err);
            setLoading_page(false);
        })
    }

    const onSearch = (e) => {
        const search = e.target.value;
        setSearch(search);
    };

    useEffect(() => {
        if (currentTeam.length > 0) {
        const id = setInterval(() => {
            updateData()
            clearInterval(id);
        }, 500);
        return () => clearInterval(id);
        }
    }, [search]);

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 font-size-18">Tổng hợp công</h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link href="#">Nhân sự</Link>
                                </li>
                                <li className="breadcrumb-item active">Tổng hợp công</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <Spin spinning={loading_page}>
                <div className="row">
                    <div className={'col-12 mb-2 d-sm-flex align-items-center justify-content-between'}>
                        <div className={'col'}>
                            <Button type="primary" className={'m-2 styleNtn_1'} onClick={()=>onQuickChangeMonth('previous')} title="Tháng trước">
                                <i className={'fa fa-arrow-left'}></i>
                            </Button>
                            {new Date(currentSelectedDate).getTime() < new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime() &&
                            <Button type="primary" className={'m-2 styleNtn_1'} onClick={()=>onQuickChangeMonth('next')} title="Tháng sau">
                                <i className={'fa fa-arrow-right'}></i>
                            </Button>}
                            <DatePicker disabledDate={disabledMonth} style={{borderRadius:10}} className={'m-2'} onChange={onChangeMonth} picker={'month'} value={currentSelectedDate} format={'MM/YYYY'} allowClear={false} disabled={loading} />

                            <div className="styleBadge">
                                <Badge.Ribbon text="Bộ phận" color="gray" style={{color:"red"}}>
                                    <TreeSelect {...tPropsConfig_BoPhan} />
                                </Badge.Ribbon>
                            </div>
                            <div className="styleBadge">
                                <Badge.Ribbon text="Team" color="gray" style={{color:"red"}}>
                                    <TreeSelect {...tPropsConfig} />
                                </Badge.Ribbon>
                            </div>



                            {/* {statusAll && userInfo && userInfo.user_permissions && systemGroup && systemGroup.length > 0 && currentTeam.length > 0 &&
                            <GetLsButton permissions={userInfo.user_permissions} systemGroup={systemGroup} status={statusAll}/>} */}
                        </div>
                        <div className={"col"}>
                            <Row gutter={[8, 8]} style={{ flexDirection: "row-reverse" }}>
                                <Col>
                                    <Button type="primary" className={'m-2'} onClick={onChotCong}>Chốt công</Button>
                                </Col>
                                <Col>
                                    <Button
                                        type={'danger'}
                                        className={'m-2 btnGreen'}
                                        style={{marginRight: 5}}
                                        onClick={fileDownload_TongHopCong}>
                                        Tải xuống
                                    </Button>
                                </Col>
                                <Col>
                                    <Search
                                        placeholder="Tìm mã NV, username"
                                        size="middle"
                                        onChange={onSearch}
                                        loading={false}
                                        className={'m-2 styleSearch'}
                                        suffix={<SearchOutlined className="site-form-item-icon" />}
                                        enterButton
                                    />
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
                <div className="row">
                <Spin spinning={loading}>
                {/* {data.length > 0 && */}
                    <Table
                        dataSource={data}
                        columns={columns}
                        loading={loading}
                        className={'custom-table-hover style-6'}
                        bordered={true}
                        scroll={{x:1920,y:500}}
                        size={'small'}
                        rowKey="id"
                        onChange={handleChange}
                        // pagination={{
                        //     current: pager.current,
                        //     pageSize: pager.pageSize,
                        //     total: pager.count,
                        //     showSizeChanger: true,
                        //     showQuickJumper: true,
                        //     pageSizeOptions: ['10', '15', '25', '50']

                        // }}
                        pagination={false} // 240223
                    />
                {/* } */}
                </Spin>
                </div>
            </Spin>
        </>
    )
}